import _ from 'lodash';
// STREM-7540 / CodeQL js/redos: domain segment rewritten from `([a-z0-9A-Z]+[-]?)+`
// (nested quantifier, exponential backtracking on long alphanumeric input) to
// `[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*-?` — a linear-time, semantically-equivalent form
// (start with alnum, no consecutive hyphens, optional trailing hyphen) with no
// overlapping alternations. Each `.label` segment is bounded to {2,63} chars:
// the upper bound (63) matches the RFC 1035 DNS label maximum and eliminates
// residual O(n²) backtracking on malformed long TLD-like input; the lower
// bound (2) is an application-level minimum (single-character TLDs/labels are
// rejected on purpose — RFC 1035 itself allows 1–63). Update the spec cases
// alongside this bound if the product policy changes.
let EMAIL_REGEX = /^[a-z0-9A-Z!#\$%&'\*\+/=\?\^_`\{\|\}~,\-]+(\.[_a-z0-9A-Z!#\$%&'\*\+/=\?\^_`\{\|\}~,\-]+)*@[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*-?(\.[a-z0-9A-Z]{2,63})+$/;

class FormValidationService {
  constructor() {
    this.EMAIL_REGEX = EMAIL_REGEX;
  }

  touchFormFields(formName) {
    let fields = this.getFormFields(formName);

    _.each(fields, function(field) {
      if (field.$pristine) {
        field.$setTouched(true);
      }
    });
  }

  getFormFields(formName) {
    let fields = [];

    _.each(formName, function(value, key) {
      let firstLetter = key.slice(0, 1);
      if (firstLetter !== '$') {
        fields.push(value);
      }
    });
    return fields;
  }

  isFormFieldErroneous(formName, formField) {
    return formName[formField].$error;
  }

  isFieldLessThanMinlength(formName, formField) {
    return formName[formField].$error.minlength;
  }

  isFieldExceedingMaxlength(formName, formField) {
    return formName[formField].$error.maxlength;
  }

  isRequiredInputFieldTouchedAndEmpty(formName, formField) {
    return formName[formField].$touched && formName[formField].$error.required;
  }
}

export default FormValidationService;



// WEBPACK FOOTER //
// ./app/common/formValidation/formValidation.service.js